<template>
  <div
    :class="{
      'card-box-sizing': theme == 'athena',
      'athena-product-card': theme == 'athena',
    }"
    style="width: 100%; padding: 20px; background: #f3f3f5"
  >
    <a
      v-if="productDetail"
      :class="layout == 'waterfall' ? 'water' : 'columns'"
      :href="
        variant_src_id
          ? `${productDetail.path}?variant=${variant_src_id}` ||
            `${productDetail.public_url}?variant=${variant_src_id}`
          : productDetail.path || productDetail.public_url
      "
      :title="productDetail.post_title || productDetail.title"
    >
      <div
        class="product_item"
        :class="{
          p_list_2: !filter_onoff && product_list_layout === '2columns',
          p_list_3:
            (!filter_onoff && product_list_layout === '3columns') ||
            (filter_onoff && product_list_layout === '2columns'),
          p_list_4:
            (!filter_onoff && product_list_layout === '4columns') ||
            (filter_onoff && product_list_layout === '3columns'),
          p_list_5: filter_onoff && product_list_layout === '4columns',
        }"
      >
        <div class="product_media">
          <div
            :class="[
              theme == 'venue' && card_radio == 'vertical'
                ? 'vertical2'
                : card_radio || 'square',
            ]"
            class="product_media_img"
          >
              <v-lazy-img
                :data-url="getProductImage()"
                :alt="productDetail.post_title"
                @load.once="load && load()"
                class="img-fluid lazyload"
              />
          </div>
          <!-- 销售标签 -->
          <template>
            <div
              v-if="
                theme == 'vogue' &&
                stock &&
                regularPrice > price &&
                sale_image_show
              "
              class="vogue_sales_label"
              :style="{
                background: `url(${
                  sale_image ? sale_image : '@/images/vogue-sale.png'
                })`,
              }"
            >
              <div class="item">
                <p>{{ preferential_percentage }}%</p>
                <p>OFF</p>
              </div>
            </div>
            <div
              v-if="theme == 'venue' && stock && regularPrice > price"
              class="product_label venue_sales_label title_font2"
            >
              <p class="product_label_text secondary_title">
                {{ $t("venue.productList.on_sale") }}
              </p>
            </div>
            <div
              v-if="!stock"
              class="product_label venue_sales_label title_font2"
            >
              <p class="product_label_text secondary_title text-uppercase">
                {{ $t("venue.productList.sold_out") }}
              </p>
            </div>
          </template>
          <!-- 购买按钮 -->
          <template v-if="theme !== 'athena'">
            <button
              v-if="
                buy_button_style &&
                stock &&
                productDetail.variants_detail &&
                productDetail.variants_detail.length <= 1
              "
              :disabled="disabled"
              v-show="
                !(
                  productDetail.custom_button &&
                  productDetail.custom_button.custom_button &&
                  productDetail.custom_button.custom_button.is_cart_card === 1
                )
              "
              :productDetail="JSON.stringify(productDetail)"
              class="addcart main_button secondary_title"
              :class="
                (buy_button_style === 'none' && 'addcart_none') ||
                (buy_button_style === 'always' && 'addcart_always') ||
                'addcart_hover'
              "
              @click="addcart"
            >
              {{ $t("venue.productList.add_to_cart") }} +
            </button>
            <button
              v-if="
                buy_button_style &&
                stock &&
                productDetail.variants_detail &&
                productDetail.variants_detail.length > 1
              "
              :disabled="disabled"
              class="addcart main_button secondary_title"
              :class="
                (buy_button_style === 'none' && 'addcart_none') ||
                (buy_button_style === 'always' && 'addcart_always') ||
                'addcart_hover'
              "
              @click="go"
            >
              {{ $t("venue.productList.selected_options") }} >
            </button>
          </template>
        </div>
        <div
          class="product_details"
          :style="{ textAlign: text_align || 'center' }"
        >
          <h3
            class="product_title h4 page_text_font"
            :style="{ fontSize: font_size ? font_size + 'px' : '14px' }"
          >
            {{ productDetail.post_title || productDetail.title }}
          </h3>
          <!-- <h5 v-if="theme == 'athena'" class="product_subtitle">
            {{ productDetail.subtitle }}
          </h5> -->
          <v-product-palette
            type="card"
            v-if="
              palette_config &&
              ((productDetail.product_palette &&
                productDetail.product_palette.length) ||
                ($store.state.product_palette_list[productDetail.ID] &&
                  $store.state.product_palette_list[productDetail.ID].length))
            "
            :palette_attrs="[
              productDetail.product_palette
                ? productDetail.product_palette[0]
                : $store.state.product_palette_list[productDetail.ID][0],
            ]"
            :variant_attrs="variant"
            :palette_config="palette_config"
            :mouse_enter="false"
            :url="productDetail.path || productDetail.public_url"
            :keys="keys"
            :theme="theme"
          ></v-product-palette>
          <div
            v-if="
              show_star && comment && !product_list_layout && theme != 'athena'
            "
            :style="{'visibility':!(show_star === 'only' && Number(productDetail.review_count) === 0)?'visible':'hidden'}"
          >
            <v-star
              :disabled="true"
              :average_rating="
                productDetail.average_rating
                  ? productDetail.average_rating
                  : '0'
              "
              :font_size="16"
            ></v-star>
            ({{
              productDetail.review_count ? productDetail.review_count : "0"
            }})
          </div>

          <p
            class="athena_price"
            :class="product_price === 'hover' ? 'product_details_hover' : ''"
          >
            <v-selectprice
              v-if="stock || theme == 'vogue'"
              :price="computed_price.price"
              :font-size="show_currency_selector ? 16 : 20"
              :regular-font-size="show_currency_selector ? 14 : 17"
              :regular_price_num="
                computed_price.regular_price > computed_price.price &&
                computed_price.regular_price
              "
              :disable_select="disable_select"
              :country="!show_currency_selector ? '' : $store.state.pricetype"
              :show_country="false"
            ></v-selectprice>
          </p>
          <p v-if="theme == 'venue' && !stock" class="sold_out secondary_title">
            {{ $t("venue.productList.sold_out") }}
          </p>
        </div>
      </div>
      <div
        class="guess_card_bottom"
        v-if="theme == 'athena' && show_add_card_btn !== false"
      >
        <div
          v-if="show_star && (product_list_layout || theme == 'athena')"
          class="ahtena_star"
          :style="{'visibility':!(show_star === 'only' && Number(productDetail.review_count) === 0)?'visible':'hidden'}"
        >
          <v-star
            :disabled="true"
            :average_rating="
              productDetail.average_rating ? productDetail.average_rating : '0'
            "
            :font_size="20"
          ></v-star>
          <span class="ahtena_star-num">
            ({{ productDetail.review_count || "0" }})
          </span>
        </div>
        <v-guesslike-add-card-btn
          :stock="stock"
          :theme="theme"
          :cart_type="cart_type"
          :product_res="product_res"
          :variant_attrs="variant"
          @clickAdd="add_cart()"
        ></v-guesslike-add-card-btn>
      </div>
    </a>
  </div>
</template>

<script>
import googleAnalysis from "@/js/lib/ga";
import { mapState } from 'vuex';
import mixAdd from "@/js/mixins/mixAdd";
import mixProduct from "@/js/mixins/mixProduct";
import mixProductTag from "@/js/mixins/mixProductTag";
import vStar from "@/js/components/view/comments/commentsstar";
import vProductPalette from "@/js/components/view/productpalette/index";
import vGuesslikeAddCardBtn from "./guesslikeaddCardBtn.vue";
import vCombinationCard from "@/js/components/view/combinations/combinationCard.vue";
//import LazyImg from '@/js/components/LazyImg.vue';
export default {
  props: [
    "productDetail",
    "cart_type",
    "show_currency_selector",
    "layout",
    "theme",
    "card_animate", // 滑动显示第二张产品图片
    "buy_button_style", // 快捷购买按钮
    "text_align", // 文字居中，靠左
    "product_price", // 商品价格
    "card_radio", // 卡片形状
    "sales_label", // 销售标签
    "disable_select", // 是否开启货币选择
    "sale_image",
    "sale_image_show",
    "font_size",
    "custom_button", //自定义按钮配置
    "model", //自定义按钮模式
    // "product_palette",
    "palette_config",
    "keys",
    "product_list_layout",
    "filter_onoff",
    "load",
    "comment",
    "show_add_card_btn", //athena加购按钮,在历史浏览插件中干掉为false
  ],
  mixins: [mixAdd, mixProduct, mixProductTag],
  data() {
    return {
      // defaultImage,
      price: 0,
      regularPrice: 0,
      stock: true,
      cardStyle: {},
      disabled: false,
      selected_variant: [],
      palette_img: "",
      variant_src_id: null,

      product: {},
      product_res: {},
      now_variant: {},
      add_cart_data: {
        product_id: null,
        quantity: 1,
      },
      page_size: 0,
      addType:'guessLike',
    };
  },
  methods: {
    getProductImage(){
      const imageData = this.productDetail?.feature_image
      if(imageData){
        return imageData.url != '' ? imageData.url : imageData.thumbnail
      }else{
        return ''
      }
    },
    go(event) {
      event.preventDefault();
      window.open(this.productDetail.public_url, "_self");
    },
    async addcart(event) {
      event.preventDefault();
      const { variants_detail } = this.productDetail;
      let add_cart_data = {};
      if (variants_detail && variants_detail.length > 0) {
        add_cart_data = {
          product_id: this.productDetail.ID,
          variant_id: variants_detail[0].id,
          quantity: 1,
        };
      } else {
        add_cart_data = {
          product_id: this.productDetail.ID,
          quantity: 1,
        };
      }
      try {
        this.disabled = true;
        this.$store.dispatch("change_button_disabled", true);
        let res = await this.$axios.post(API.addcart, {...add_cart_data,addType:'guesslike'});
        if (window.fbq) {
          if (variants_detail && variants_detail.length > 0) {
            this.send_fb_event("AddToCart", {
              content_type: "product_group",
              content_ids: [variants_detail[0].id],
              value: variants_detail[0].price,
              num_items: 1,
              content_name: this.productDetail.title,
              currency: res.data.currency,
              content_category: this.productDetail.categories || [],
            });
          } else {
            this.send_fb_event("AddToCart", {
              content_type: "product_group",
              content_ids: [this.productDetail.ID],
              value: this.productDetail.price,
              num_items: 1,
              content_name: this.productDetail.title,
              currency: res.data.currency,
              content_category: this.productDetail.categories || [],
            });
          }
        }
        if (window.ttq && window.send_ttp_event) {
          window.send_ttp_event('AddToCart', {
            content_id: [this.productDetail.ID],
            quantity: 1,
            value: this.productDetail.price,
            currency: window.checkoutcurrency || 'USD',
          })
        }
        if (window._learnq) {
          this.klaviyo_addtocart(this.productDetail, add_cart_data);
        }
        // if (window.gtag) {
        //   window.gtag("event", "add_to_cart");
        // }
        // 添加到购物车
        googleAnalysis.event(googleAnalysis.gaAction.add);

        this.$store.dispatch("change_news_cart", res.data);
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
        if (
          (this.theme == "venue" || this.theme == "showtime") &&
          this.cart_type == "popup"
        ) {
          this.disabled = false;
          this.$("#modalCart").modal("show");
        } else if (
          this.theme == "vogue" &&
          (this.cart_type == "drawer" || this.cart_type == "popup")
        ) {
          this.showInlineCart();
          this.disabled = false;
        } else {
          window.open("/cart", "_self");
          setTimeout(() => {
            this.disabled = false;
            this.$store.dispatch("change_button_disabled", false);
          }, 5000);
        }
      } catch (error) {
        this.disabled = false;
        this.$store.dispatch("change_button_disabled", false);
        if (
          error?.response?.data?.errors
        ) {
          this.$message.error(Object.values(error.response.data.errors)[0][0]);
        } else if (error?.response?.data?.message) {
          this.$message.error(error.response.data.message);
        }
      }
    },
    combineSize() {
      let combineWidth = this.screenWidth > 768 ? 67 : 50;
      if (this.$("div.combine").length > 0) {
        // this.screenWidth = this.$(window).width();
        let nexSize = this.$("div.product_details").width() / combineWidth;
        if (this.page_size != nexSize) {
          this.page_size = nexSize;
        }
      }
    },
    aabb() {
      let combineWidth = this.screenWidth > 768 ? 67 : 50;
      return this.$("div.product_details").width() / combineWidth;
    },
  },
  mounted() {
    this.combineSize();
    window.addEventListener("resize", () => {
      this.combineSize();
    });
  },
  computed: {
    // 计算属性的 getter
    preferential_percentage: function () {
      if (this.regularPrice < this.price) {
        return 0;
      } else {
        return Math.ceil((1 - this.price / this.regularPrice) * 100);
      }
    },
    preferential_fix: function () {
      if (this.regularPrice < this.price) {
        return 0;
      } else {
        return (this.regularPrice - this.price).toFixed(2);
      }
    },
    ...mapState({
      // 产品卡片评论星星配置
      show_star: ({ options }) => options?.theme?.global?.product_cart?.show_star,
      screenWidth: ({ screenWidth }) => screenWidth
    }),
  },
  watch: {
    productDetail: {
      handler(newV) {
        this.product = this.productDetail;
        this.add_cart_data.product_id = newV.ID;
        let copy_product = JSON.stringify(newV);
        this.product_res = JSON.parse(copy_product);
        this.now_variant = JSON.parse(copy_product);
        if (newV.variant_attrs && newV.variant_attrs.length) {
          this.create_attrs();
        }
        const { variants_detail, regular_price, price, min_price, buy_able } =
          newV;
        if (variants_detail && variants_detail.length > 0) {
          const filterMinProduct = variants_detail.filter(
            (item) => item.price == min_price
          );
          if (filterMinProduct) {
            filterMinProduct.sort(function (a, b) {
              return a.regular_price - b.regular_price;
            });
          }
          this.price = (min_price && Number(min_price)) || 0;
          this.regularPrice =
            (filterMinProduct &&
              filterMinProduct[0] &&
              Number(filterMinProduct[0].regular_price)) ||
            0;
        } else {
          this.price = (price && Number(price)) || 0;
          this.regularPrice =
            regular_price && regular_price > price ? Number(regular_price) : 0;
        }
        if (buy_able) {
          this.stock = true;
        } else {
          this.stock = false;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  components: {
    vStar,
    vProductPalette,
    vGuesslikeAddCardBtn,
    vCombinationCard,
    //LazyImg,
  },
};
</script>

<style scoped lang='scss'>
.columns {
  .product_media_img {
    width: 100%;
    padding-top: 100%;
    position: relative;

    .img-fluid {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      backface-visibility: hidden;
      transition: all 0.3s ease-in-out;
    }

    .product_media_img_hover {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background-size: cover;
      background-position: center;
      opacity: 0;
      padding: 0 15px 0 0;
      visibility: hidden;
      transition: all 0.2s ease-in;
    }
  }
  .square {
    padding-top: 100% !important;
  }

  .horizon {
    padding-top: 75% !important;
  }

  .vertical {
    padding-top: 133% !important;
  }

  .vertical2 {
    padding-top: 150% !important;
  }
  .auto {
    padding-top: unset;
    .img-fluid {
      position: relative;
      display: block;
    }
  }
}
.water {
  .product_media_img {
    width: 100%;
    position: relative;

    .img-fluid {
      width: 100%;
      backface-visibility: hidden;
      transition: all 0.3s ease-in-out;
    }

    .product_media_img_hover {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background-size: cover;
      background-position: center;
      opacity: 0;
      padding: 0 15px 0 0;
      visibility: hidden;
      transition: all 0.2s ease-in;
    }
  }
}
a {
  .product_item {
    width: 100%;
    margin-bottom: 20px;
    break-inside: avoid;
    display: flex;
    .product_media {
      width: 30%;
      box-sizing: inherit;
      position: relative;
      max-width: 120px;
      .addcart {
        width: 100%;
        background-color: black;
        color: white;
        height: 32px;
        position: absolute;
        bottom: 0px;
        font-size: 12px;
        opacity: 0.8;
      }

      .addcart_hover {
        display: none;
      }

      .addcart_always {
        display: block;
      }

      .addcart_none {
        display: none;
      }

      .product_label {
        position: absolute;
        background: #d34a4a;
        top: 4px;
        right: -6px;
        padding: 2px 10px;
        z-index: 1;

        .product_label_text {
          line-height: 26px;
          color: #fff;
          font-family: "oswald", sans-serif;
          letter-spacing: 1px;
          font-size: 13px;
          font-weight: 400;
          margin: 0;
        }
      }
      .vogue_sales_label {
        position: absolute;
        right: 0;
        top: 0;
        width: 66px;
        height: 66px;
        z-index: 10;
        transform: scale(0.9);
        background-size: cover !important;
        text-align: center;
        color: #fff;
        font-size: 18px;
        font-weight: 600;
        .item {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          transform: translate(-50%, -50%);
        }
        p {
          margin: 0;
        }
        p:nth-last-child(1) {
          font-size: 12px;
        }
      }
    }

    .product_details {
      text-align: center;
      .sold_out {
        font-size: 14px;
        color: #1e0909;
      }

      .product_title {
        margin: 0;
        font-size: 14px;
        line-height: 1.8;
        // text-transform: uppercase;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
      }
      .product_subtitle {
        font-size: 18px;
        margin-top: 13px;
        white-space: nowrap;
        line-height: 23px;
        height: 23px;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-weight: 400;
        color: #888888;
      }

      p {
        // margin-top: 6px;
        margin-bottom: 0px;

        .product_price_price {
          font-family: "oswald", sans-serif;
          line-height: 1;
          font-size: 1rem;
          margin-top: 6px;
        }

        .product_price_cross {
          font-family: "oswald", sans-serif;
          position: relative;
          margin-left: 6px;
          text-decoration: line-through;
          font-size: 0.9em;
          color: #b89797;
          font-size: 1rem;
        }
      }
    }

    .product_details_hover {
      display: none;
      // height: 0;
    }
  }


    .product_media:hover {
      .addcart_hover {
        display: block;
      }
      .product_media_img {
        .img-fluid {
          opacity: 0.9;
        }

        .product_media_img_hover {
          opacity: 1;
          visibility: visible;
        }
      }


    .product_details {
      .product_title {
        opacity: 0.7;
      }
    }

    .product_details_hover {
      display: block;
      transition: all 0.5s;
    }
  }
}
.card-box-sizing {
  box-shadow: 0px 2px 10px 0px rgba(108, 108, 108, 0.24);
}
.athena-product-card {
  .columns {
    .product_item {
      .product_details {
        padding-left: 10px;
        line-height: 1;
        width: 70%;
        .product_title {
          font-size: 16px !important;
          line-height: 1.2;
          padding-left: 0.1rem;
          font-family: Roboto;
          font-weight: 500;
          color: #222222;
        }

        &::v-deep .selectpricewrap {
          margin-top: 10px;
          .product_price_cross {
            line-height: 1;
          }
          .money {
            font-size: 16px !important;
          }
        }
        .variant_attrs_box {
          margin-top: 15px;
        }
        .ahtena_star {
          margin-top: 10px;
          &::v-deep .starWrap {
            font-size: 24px;
            .el-rate {
              height: auto;
              margin-right: 5px;
              .el-rate__icon,
              .el-icon-star-on {
                color: black !important;
                font-size: 29px !important;
              }
              &__decimal {
                color: #000000 !important;
              }
            }
          }
          &-num {
            font-size: 20px;
          }
        }
      }
    }
  }
}
.combination_card {
  height: 82px;
}
.guess_card_bottom {
  position: relative;
  .ahtena_star {
    position: absolute;
    line-height: 1;
    &::v-deep .starWrap {
      .el-rate {
        .el-rate__icon,
        .el-icon-star-on {
          color: black !important;
        }
        &__decimal {
          color: #000000 !important;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .combination_card {
    height: 75px;
  }
}
@media screen and (max-width: 575px) {
  .athena-product-card {
    .columns {
      .product_item {
        .product_details {
          padding-top: 0;
          padding-left: 10px;
          padding-right: 10px;
          .product_title {
            font-size: 13px !important;
            line-height: 1.24;
            padding-left: 0.1rem;
            font-family: Roboto;
            font-weight: 500;
            color: #222222;
            text-align: left;
          }
          .product_subtitle {
            font-size: 12px;
            margin-top: 5px;
            text-align: left;
          }
          &::v-deep .selectpricewrap {
            margin-top: 0;
            .product_price_cross {
              line-height: 1;
            }
            .money {
              font-size: 12px !important;
            }
          }
          .variant_attrs_box {
            margin-top: 15px;
          }
          .athena_price {
            text-align: left;
          }
          .ahtena_star {
            margin-top: 0;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            &::v-deep .starWrap {
              .el-rate {
                .el-rate__icon,
                .el-icon-star-on {
                  font-size: 14px !important;
                }
              }
            }
            .ahtena_star-num {
              font-size: 12px;
              zoom: 0.83;
              margin-top: 5px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 575px) {
  .product_item {
    .product_details_hover {
      display: block !important;
      // height: auto !important;
    }
    .addcart_hover {
      display: block !important;
    }
    .product_label {
      padding: 2px 6px !important;
      .product_label_text {
        font-size: 12px !important;
      }
    }
    .vogue_sales_label {
      width: 50px !important;
      height: 50px !important;
      font-size: 12px !important;
    }
  }
  .product_item {
    margin-bottom: 15px !important;
  }
  .guess_card_bottom {
    .ahtena_star {
      &::v-deep .starWrap {
        .el-rate {
          .el-rate__icon,
          .el-icon-star-on {
            font-size: 16px !important;
          }
        }
      }
    }
  }
}
</style>
